import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateSupplierInvoiceTaxLineDto {
  @Expose()
  name?: string;

  @Expose()
  percentage?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  amount?: number;
}
